import { URLS } from '@netfoundry-ui/shared/services';

export interface OrgTab {
    label: string;
    url: string;
    hidden: boolean;
}

export interface UsersTabRules {
    canListUsers: () => boolean;
    canListInvitations: () => boolean;
    canListRoleTemplates: () => boolean;
    hideRoleTemplatesTab: boolean;
}

/** The Users / User Roles / Invitations / Role Templates strip the Organization lists share, on their beta lists. */
export function usersListTabs(rules: UsersTabRules): OrgTab[] {
    return [
        {
            label: 'Users',
            url: URLS.USERS_LIST,
            get hidden() {
                return !rules.canListUsers();
            },
        },
        {
            label: 'User Roles',
            url: URLS.USER_ROLES_LIST,
            get hidden() {
                return !rules.canListUsers();
            },
        },
        {
            label: 'Invitations',
            url: URLS.MANAGE_INVITATIONS_LIST,
            get hidden() {
                return !rules.canListInvitations();
            },
        },
        {
            label: 'Role Templates',
            url: URLS.ROLE_TEMPLATES_LIST,
            get hidden() {
                return rules.hideRoleTemplatesTab || !rules.canListRoleTemplates();
            },
        },
    ];
}

/** The OIDC strip. Public Clients exists only in nfconsole, so it has no tab on the cloud-ziti lists. */
export function oidcListTabs(): OrgTab[] {
    return [
        { label: 'Oidc Issuers', url: URLS.OIDC_ISSUERS_LIST, hidden: false },
        { label: 'Oidc Audiences', url: URLS.OIDC_AUDIENCES_LIST, hidden: false },
        { label: 'Oidc Identity Audience Maps', url: URLS.OIDC_IDENTITY_AUDIENCE_MAP_LIST, hidden: false },
        { label: 'Oidc Organization to Public Client Map', url: URLS.OIDC_PUBLIC_CLIENT_ORG_MAPPING_LIST, hidden: false },
    ];
}

export const apiAccountsListTabs = (): OrgTab[] => [{ label: 'API Accounts', url: URLS.TOKENS_LIST, hidden: false }];

export const storedSecretsListTabs = (): OrgTab[] => [{ label: 'SSH Keys', url: URLS.STORED_SECRETS_LIST, hidden: false }];
